import React from 'react';
import PropTypes from 'prop-types';
import Validator from '../Validator';
import ErrorMessage from '../ErrorMessage';
import SwitchRow from '../SwitchRow';
import Loader from '../../ui/Loader';
import { extractMessageData } from '../../../../helpers/messages';

export default class SendMessage extends Validator {
  initialState = { message: '', sendSms: false, sendPushNotification: true };

  state = this.initialState;

  validationRules = { message: { required: true } };

  handleChange = event => this.setState({ [event.target.name]: event.target.value });

  handleSwitch = name => this.setState({ [name]: !this.state[name] });

  onSubmit = event => {
    event.preventDefault();

    if (this.validate(this.validationRules)) {
      this.props.onSubmit(extractMessageData(this.state))
        .then(() => this.setState(this.initialState));
    }
  };

  render () {
    return (
      <form onSubmit={this.onSubmit} className='form position-relative'>
        <div className='form-group'>
          <textarea
            autoFocus
            name='message'
            value={this.state.message}
            onChange={this.handleChange}
            className='input input-textarea input-send-message'
          />
          <ErrorMessage errorText={this.validationErrors.message} />
        </div>
        <div className='form-group d-flex'>
          <SwitchRow onChange={() => this.handleSwitch('sendSms')} checked={this.state.sendSms} label='SMS' />
          <div className='ml-4'>
            <SwitchRow onChange={() => this.handleSwitch('sendPushNotification')} checked={this.state.sendPushNotification} label='In App' />
          </div>
        </div>
        <div className='d-flex justify-content-between'>
          <button className='button button-cancel' type='button' onClick={this.props.onCancel}>Cancel</button>
          <button className='button button-primary' type='submit' disabled={this.props.isLoading}>Send</button>
        </div>

        {this.props.isLoading && (
          <Loader />
        )}
      </form>
    );
  }
}

SendMessage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/common/forms/SendMessage/index.js